import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  FormControl,
  Box,
  Select,
  Typography,
  Button,
  MenuItem,
  TablePagination,
  Avatar,
  TextField,
  Grid,
  FormHelperText,
  InputLabel,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestoreIcon from "@mui/icons-material/Restore";
import { styled } from "@mui/system";

import Colors from "../../../../assets/styles";
import { Svgs } from "../../../../assets/images";
import { useNavigate } from "react-router-dom";
import PropertyServices from "../../../../api/PropertyServices/property.index";
import AuthServices from "../../../../api/AuthServices/auth.index";
import { ErrorHandler } from "../../../../utils/ErrorHandler";
import SimpleDialog from "../../../../components/Dialog/index";
import Loader from "../../../../components/Loader";

const tableHead = [
  "SR No",
  "Unit Number",
  "Property Name",
  "Type",
  "Area",
  "Purpose",
  // "Total Selling Price",
  "Action",
];

const CustomSelect = styled(Select)({
  "&.MuiSelect-root": {
    border: "none",
    outline: "none",
    boxShadow: "none",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-icon": {
    color: "black",
  },
  "& .MuiSelect-select": {
    padding: "8px 32px 8px 8px",
  },
});

const PropertyList = () => {
  const [data, setData] = useState([]);
  const [id, setId] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [property, setProperty] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [openSoldDialog, setOpenSoldDialog] = useState(false);
  const [openDealClosedDialog, setOpenDealClosedDialog] = useState(false);
  const [agents, setAgents] = useState([]);
  const [soldBy, setSoldBy] = useState("");
  const [soldError, setSoldError] = useState("");


  const baseUrl = process.env.REACT_APP_BASE_URL;
  const sleep = () => new Promise((r) => setTimeout(r, 1000));

  const getProperties = async (
    searchParam = "",
    idParam = "",
    pageParam = 1,
    limitParam = 10,
   
  ) => {
    setLoading(true);
    try {
      await sleep();
      const { data } = await PropertyServices.getProperty(
        searchParam,
        idParam,
        pageParam,
        limitParam,
        "", "", "", "","", "","","",
        "true"
      );
      setData(data?.properties);
      setCount(data.count);
    } catch (error) {
      ErrorHandler(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getApprovedAgents = async () => {
    try {
      const { data } = await AuthServices.agentApprovalList();
      setAgents(data?.agents);
    } catch (error) {
      ErrorHandler(error);
      console.log(error);
    }
  }

  useEffect(() => {
    getApprovedAgents();
  }, []);

  useEffect(() => {
    getProperties(search, id, page + 1, limit, "","","","");
  }, [page, limit, search]);

  const deleteProperty = async () => {
    setDeleteLoading(true);
    try {
      const { responseCode } = await PropertyServices.deleteProperty(
        selectedPropertyId
      );

      setOpenDialog(false);
      getProperties(search, id, page + 1, limit,"","","","");
    } catch (error) {
      ErrorHandler(error);
      console.log(error?.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const soldProperty = async (propertyId, soldBy) => {
    if (!soldBy) {
      setSoldError("Please select who closed this sale");
      return;
    }
    setDeleteLoading(true);
    try {
      const soldType = soldBy === "self" ? "self" : "agent";
      const { responseCode } = await PropertyServices.markPropertyAsSold(
        propertyId,
        soldType,
        soldBy
      );
      setOpenSoldDialog(false);
      setSoldBy("");
      setSoldError("");
      getProperties(search, id, page + 1, limit, "", "", "", "");
    } catch (error) {
      ErrorHandler(error);
      console.log(error?.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleSearch = () => {
    getProperties(search, id, 1, limit,"","","","");
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleReset = () => {
    setId("");
    setSearch("");
    getProperties("", "", 1, limit,"","","","");
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "AED",
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 8,
        }}
      >
        <Typography
          sx={{ fontSize: "26px", color: Colors.primary, fontWeight: "600" }}
        >
          Properties
        </Typography>
        <Button
          onClick={() => navigate("/properties/create")}
          variant="contained"
          color="primary"
          sx={{ mx: 1, color: "white" }}
        >
          Add New
        </Button>
      </Box>
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
        }}
      >
        <Grid
          item
          display="flex"
          alignItems="center"
          sx={{ mt: 3, pl: 2 }}
          bgcolor={Colors.backgroundColor}
          border="1px solid rgba(10, 10, 10, 0.1)"
          borderRadius={2}
          boxShadow="0xp 0px 100px 0xp rgba(0,0,0,0.1)"
        >
          {/* <FilterAltIcon /> */}
          {/* <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          /> */}
          {/* <Box sx={{ px: 2, width: "100px" }}>Filter By</Box> */}

          {/* <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          /> */}
          <TextField
            placeholder="Search"
            InputProps={{
              sx: {
                input: {
                  paddingTop: "7px !important",
                  paddingBottom: "7px !important",
                  paddingRight: "50px !important",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <Box
            sx={{
              width: "1px",
              height: "40px",
              backgroundColor: "lightgray",
              mx: 1,
            }}
          />
          <Button
            sx={{ color: Colors.red, mx: 1 }}
            startIcon={<RestoreIcon />}
            onClick={handleReset}
          >
            Reset Filter
          </Button>
        </Grid>
      </Grid>
      <TableContainer
        sx={{
          mt: 2,
          backgroundColor: Colors.backgroundColor,
          borderRadius: "10px",
        }}
        component={Paper}
      >
        <Table>
          <TableHead>
            <TableRow>
              {tableHead.map((column, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: "600",
                    color: Colors.black,
                    textAlign:
                      column === "Management Company" ? "left" : "center",
                  }}
                >
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {loading ? (
            <TableRow>
              <TableCell colSpan={tableHead.length}>
                <Loader width="40px" height="40px" color={Colors.primary} />
              </TableCell>
            </TableRow>
          ) : (
            filteredData.map((row, index) => (
              <TableBody key={row._id}>
                <TableRow
                  onClick={() =>
                    navigate(`/properties/details/${row?._id}`, { state: row })
                  }
                >
                  <TableCell sx={{ textAlign: "center" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row?.unit_number}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row?.name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row?.type == "commercialOffice" ? "Commercial Office" :""}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row?.area + " sqft"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" ,textTransform:"capitalize" }}>
                    {row?.purpose == "both" ? "Sale-Rent (Both)" :row?.purpose }
                  </TableCell>
                  {/* <TableCell sx={{ textAlign: "center" }}>
                    {formatPrice(row?.price)}
                  </TableCell> */}
                  {row?.status == "sold" ? (
                     <TableCell 
                      sx={{ textAlign: "center", color: Colors.primary, fontWeight: "bold" }}
                      onClick={(e) => {
                        e.stopPropagation()
                        setOpenDealClosedDialog(true);
                        setProperty(row);
                      }}
                    >
                      Deal Closed
                    </TableCell>
                  ) : (
                      <TableCell sx={{ textAlign: "center" }}>
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "5px",
                          }}
                        >
                          <Box
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/properties/update/${row?._id}`, {
                                state: row,
                              });
                            }}
                            style={{paddingTop:"4px"}}
                            dangerouslySetInnerHTML={{ __html: Svgs["edit"] }}
                          />
                          {row?.purpose == "both" || row?.purpose == "sale" ?
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                setSoldBy("");
                                setSoldError("");
                                setOpenSoldDialog(true);
                                setSelectedPropertyId(row._id);
                              }}
                              title="mark as sold"
                              dangerouslySetInnerHTML={{ __html: Svgs["sold"] }}
                            />
                            : null
                          }
                          <Box
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenDialog(true);
                              setSelectedPropertyId(row._id);
                            }}
                            style={{paddingTop:"4px"}}
                            dangerouslySetInnerHTML={{ __html: Svgs["delete"] }}
                          />
                        </Typography>
                      </TableCell>
                    )}
                </TableRow>
              </TableBody>
            ))
          )}
        </Table>
      </TableContainer>
      <SimpleDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        border={`4px solid ${Colors.primary}`}
        title="Are You Sure you want to Delete?"
      >
        <Typography sx={{textAlign:"center"}}>
        Deleting this property will remove all associated bookings.
        </Typography>
        <Box
          sx={{ display: "flex", justifyContent: "center", gap: "16px", mt: 5 }}
        >
          <Box
            onClick={() => setOpenDialog(false)}
            sx={{
              background: Colors.black,
              color: Colors.primary,
              borderRadius: "10px",
              px: 5,
              py: 2,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            No, Cancel
          </Box>
          <Box
            sx={{
              color: Colors.black,
              background: Colors.primary,
              borderRadius: "10px",
              px: 5,
              py: 2,
              fontWeight: "bold",
              cursor: "pointer",
              width:deleteLoading ? "80px":"auto"
            }}
            onClick={deleteProperty}
          >
            {deleteLoading ? (
              <Loader width="20px" height="20px"  color={Colors.white} />
            ) : (
              "Yes, Confirm"
            )}
          </Box>
        </Box>
      </SimpleDialog>

      <SimpleDialog
        open={openSoldDialog}
        onClose={() => setOpenSoldDialog(false)}
        border={`4px solid ${Colors.primary}`}
        title="Mark as Sold"
      >
        <Typography sx={{ textAlign: "center" }}>
          Please select who closed this sale
        </Typography>

        <FormControl sx={{ mt: 3 }} fullWidth error={!!(soldError)}>
          <InputLabel id="sold-by-label">Sold By</InputLabel>
          <Select
            labelId="sold-by-label"
            value={soldBy}
            label="Sold By"
            onChange={(e) => {
              setSoldBy(e.target.value);
              setSoldError("");
            }}
          >
            <MenuItem value="self">
              <strong>Self Sold (Internal)</strong>
            </MenuItem>

            {agents.map((agent) => (
              <MenuItem key={agent._id} value={agent._id}>
                {agent.name}
              </MenuItem>
            ))}
          </Select>

          {soldError && (
            <FormHelperText>{soldError}</FormHelperText>
          )}
        </FormControl>

        <Box
          sx={{ display: "flex", justifyContent: "center", gap: "16px", mt: 5 }}
        >
          <Box
            onClick={() => {setOpenSoldDialog(false); setSoldError(""); setSoldBy("");}}
            sx={{
              background: Colors.black,
              color: Colors.primary,
              borderRadius: "10px",
              px: 5,
              py: 2,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            No, Cancel
          </Box>
          <Box
            sx={{
              color: Colors.black,
              background: Colors.primary,
              borderRadius: "10px",
              px: 5,
              py: 2,
              fontWeight: "bold",
              cursor: "pointer",
              width: deleteLoading ? "80px" : "auto"
            }}
            onClick={() => soldProperty(selectedPropertyId, soldBy)}
          >
            {deleteLoading ? (
              <Loader width="20px" height="20px" color={Colors.white} />
            ) : (
              "Yes, Confirm"
            )}
          </Box>
        </Box>
      </SimpleDialog>

      <SimpleDialog
        open={openDealClosedDialog}
        onClose={() => setOpenDealClosedDialog(false)}
        border={`4px solid ${Colors.primary}`}
        title="Closed Deal Details"
      >
        <Box sx={{ mt: 1 }}>
          {/* SOLD TYPE */}
          <Typography sx={{ fontWeight: 600, mb: 1 }}>
            Sold Type:
            <span style={{ marginLeft: 6, textTransform: "capitalize" }}>
              {property?.soldType === "agent" ? "Agent Sold" : "Internal Sold"}
            </span>
          </Typography>

          {/* AGENT SOLD */}
          {property?.soldType === "agent" && property?.soldAgent && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                Agent Details:
              </Typography>

              <Typography>
                <b>Name:</b> {property.soldAgent.name}
              </Typography>

              <Typography>
                <b>Email:</b> {property.soldAgent.email}
              </Typography>

              <Typography>
                <b>Phone:</b> {property.soldAgent.phone}
              </Typography>
            </Box>
          )}

          {/* INTERNAL SOLD */}
          {property?.soldType !== "agent" && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontWeight: 600 }}>
                This property was sold internally (Self Sold).
              </Typography>
            </Box>
          )}

          {/* SOLD DATE */}
          {property?.soldAt && (
            <Box sx={{ mt: 2 }}>
              <Typography>
                <b>Sold On:</b>{" "}
                {new Date(property.soldAt).toLocaleDateString()}
              </Typography>
            </Box>
          )}
        </Box>
      </SimpleDialog>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: "text.secondary", ml: 2 }}>
          {`Showing ${page * limit + 1}-${Math.min(
            (page + 1) * limit,
            count
          )} of ${count}`}
        </Typography>
        <Box>
          <TablePagination
            component={Paper}
            sx={{
              borderBottom: "none",
              border: "1px solid black",
              bgcolor: "transparent",
              ".MuiTablePagination-toolbar": {
                paddingLeft: 0,
              },
              ".MuiTablePagination-spacer": {
                flex: "none",
              },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                {
                  display: "none",
                },
              ".MuiTablePagination-actions": {
                marginLeft: 0,
              },
              ".MuiTablePagination-actions button:first-child": {
                borderRadius: 0,
                p: 0,
                pr: "8px",
                borderRight: "1px solid black",
              },
              ".css-78c6dr-MuiToolbar-root-MuiTablePagination-toolbar .MuiTablePagination-actions":
                {
                  marginLeft: "14px !important",
                },
              ".MuiTablePagination-toolbar": {
                minHeight: "14px !important",
                padding: "0px !important",
              },
            }}
            rowsPerPageOptions={[]} // Removes rows per page selector
            count={count}
            rowsPerPage={limit}
            page={page}
            onPageChange={handlePageChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PropertyList;
